import React from 'react';
import { classPrefix } from 'react-select-datepicker/dist/utils/helpers';
import RSelect from 'react-select';
import clsx from 'clsx';
import styles from './SelectDatepicker.module.scss';

export type Option = {
  value: number;
  label: string;
}

interface ISelectRenderer {
  id: string;
  labels: {
    hide?: boolean;
    main?: string;
    placeholder?: string;
  };
  value: Option | null;
  disabled?: boolean;
  onChangeHandler: (e: Option | null) => void;
  selectOptions: Option[];
  white?: boolean;
}

export function SelectRenderer({
  id,
  labels,
  value,
  selectOptions,
  disabled,
  onChangeHandler,
  white,
}: ISelectRenderer) {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column' }}
      className={clsx(styles.item, white && styles.itemWhite)}
    >
      {!labels.hide && <label htmlFor={`${classPrefix}_select-${id}`} className={styles.label}>{labels.main}</label>}
      <RSelect
        id={`${classPrefix}_select-${id}`}
        className={`${classPrefix}_select-${id}`}
        classNamePrefix="select"
        value={value}
        name="color"
        isDisabled={disabled}
        onChange={(e) => onChangeHandler(e)}
        options={selectOptions}
        isSearchable={false}
        placeholder={labels.placeholder}
        classNames={{
          control: (state) => clsx(styles.control, state.menuIsOpen && styles.controlMenuIsOpen),
          indicatorSeparator: () => styles.indicatorSeparator,
          valueContainer: () => styles.valueContainer,
          placeholder: () => styles.placeholder,
          singleValue: () => styles.singleValue,
          dropdownIndicator: () => styles.dropdownIndicator,
          menu: () => styles.menu,
          menuList: () => styles.menuList,
          option: (state) => clsx(
            styles.option,
            state.isSelected && styles.optionSelected,
            state.isFocused && styles.optionFocused,
          ),
        }}
      />
    </div>
  );
}
